(function () {
  'use strict';

  var form = document.getElementById('bz-bf-form');
  var signup = document.getElementById('bz-inscriere');

  // După trimitere, Shopify reîncarcă pagina: aducem confirmarea sau eroarea în ecran.
  var feedback = document.querySelector('[data-bz-success], [data-bz-errors]');
  if (feedback) {
    feedback.scrollIntoView({ block: 'center' });
    feedback.focus({ preventScroll: true });
  }

  if (form && !document.querySelector('[data-bz-success]')) {
    var fields = form.querySelectorAll('input[data-msg]');
    var phone = form.querySelector('#bz-telefon');

    var normalizePhone = function (value) {
      var digits = value.replace(/[\s().-]/g, '');
      if (!digits) return '';
      if (/^07\d{8}$/.test(digits)) return '+4' + digits;
      if (/^0040\d{9}$/.test(digits)) return '+' + digits.slice(2);
      if (/^40\d{9}$/.test(digits)) return '+' + digits;
      if (/^\+\d{8,15}$/.test(digits)) return digits;
      return null;
    };

    var showError = function (input) {
      var id = input.id + '-err';
      var existing = document.getElementById(id);
      if (input.validity.valid) {
        input.removeAttribute('aria-invalid');
        input.removeAttribute('aria-describedby');
        if (existing) existing.remove();
        return;
      }
      input.setAttribute('aria-invalid', 'true');
      input.setAttribute('aria-describedby', id);
      if (!existing) {
        existing = document.createElement('p');
        existing.id = id;
        existing.className = 'bz-field-error';
        var anchor = input.type === 'checkbox' ? input.closest('.bz-consent') : input;
        anchor.insertAdjacentElement('afterend', existing);
      }
      existing.textContent = input.dataset.msg;
    };

    var check = function (input) {
      input.setCustomValidity('');
      if (input === phone && input.value.trim() && normalizePhone(input.value) === null) {
        input.setCustomValidity(input.dataset.msg);
      } else if (input.type === 'email' && input.value.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(input.value.trim())) {
        input.setCustomValidity(input.dataset.msg);
      } else if (!input.checkValidity()) {
        input.setCustomValidity(input.dataset.msg);
      }
      return input.validity.valid;
    };

    fields.forEach(function (input) {
      input.addEventListener('invalid', function () { showError(input); });
      input.addEventListener(input.type === 'checkbox' ? 'change' : 'blur', function () {
        check(input);
        if (input.getAttribute('aria-invalid') || !input.validity.valid) showError(input);
      });
      input.addEventListener('input', function () {
        if (input.getAttribute('aria-invalid')) { check(input); showError(input); }
      });
    });

    form.addEventListener('submit', function (event) {
      var ok = true;
      fields.forEach(function (input) { if (!check(input)) ok = false; });
      if (!ok) {
        event.preventDefault();
        fields.forEach(showError);
        var first = form.querySelector('[aria-invalid="true"]');
        if (first) first.focus();
        return;
      }
      if (phone) {
        var normalized = normalizePhone(phone.value);
        if (normalized) phone.value = normalized;
        else phone.disabled = true; // câmp gol: nu trimitem telefonul
      }
      var button = form.querySelector('button[type="submit"]');
      if (button) {
        // după ce browserul a preluat trimiterea, blocăm al doilea click
        setTimeout(function () { button.disabled = true; }, 0);
      }
    });
  }

  // Formularul theMarketer se încarcă din scriptul aplicației. Rezervăm locul cât se încarcă,
  // iar dacă nu apare în 10 secunde, arătăm un mesaj cu reîncărcare în loc de un gol.
  var mktr = signup && signup.querySelector('.mktr-embedded-form-container');
  if (mktr) {
    var ready = function () { return !!mktr.querySelector('input'); };
    if (!ready()) {
      signup.classList.add('bz-loading');
      var started = Date.now();
      var timer = setInterval(function () {
        if (ready()) {
          clearInterval(timer);
          signup.classList.remove('bz-loading');
        } else if (Date.now() - started > 10000) {
          clearInterval(timer);
          signup.classList.remove('bz-loading');
          var box = document.createElement('div');
          box.className = 'bz-error-box';
          box.setAttribute('role', 'alert');
          box.innerHTML = '<p>Formularul nu s-a încărcat. Reîncarcă pagina sau scrie-ne la office@bluzat.com.</p>' +
            '<button type="button" class="bz-button bz-button--ghost">Reîncarcă pagina</button>';
          box.querySelector('button').addEventListener('click', function () { location.reload(); });
          signup.insertBefore(box, signup.firstChild);
        }
      }, 200);
    }
  }

  // După înscriere rămâne vizibilă doar confirmarea theMarketer.
  if (signup) {
    var watchDone = setInterval(function () {
      var ok = signup.querySelector('.mkt-embedded-form-success-message');
      if (ok && getComputedStyle(ok).display !== 'none' && ok.offsetHeight > 0) {
        clearInterval(watchDone);
        // Înscrierea reușită, trimisă spre măsurare: evenimentul Shopify (pentru pixelul custom din admin),
        // GTM/GA4 și pixelurile Meta/TikTok, dacă sunt încărcate direct în pagină.
        try {
          var ev = { form: 'Black Friday 2026', page: location.pathname };
          if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('bf_inscriere', ev);
          window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'bf_inscriere', form: ev.form });
          // Lead o singură dată pe dispozitiv: retrimiterile celor deja înscrise nu mai sunt numărate ca lead-uri noi.
          var leadKey = 'bz_bf2026_lead';
          var leadSent = false;
          try { leadSent = !!localStorage.getItem(leadKey); } catch (e2) {}
          if (!leadSent) {
            try { localStorage.setItem(leadKey, String(Date.now())); } catch (e3) {}
            if (typeof window.fbq === 'function') window.fbq('track', 'Lead', { content_name: ev.form });
            if (window.ttq && typeof window.ttq.track === 'function') window.ttq.track('SubmitForm', { content_name: ev.form });
          }
        } catch (e) {}
        // theMarketer ascunde confirmarea după câteva secunde; o înlocuim cu una permanentă.
        var done = document.createElement('div');
        done.className = 'bz-success';
        done.setAttribute('role', 'status');
        done.setAttribute('tabindex', '-1');
        var t = document.createElement('p'); t.className = 'bz-success__title'; t.textContent = signup.dataset.successTitle || 'Ești pe listă.';
        var x = document.createElement('p'); x.textContent = signup.dataset.successText || '';
        var a = document.createElement('a'); a.className = 'bz-link'; a.href = '/'; a.textContent = 'Până atunci, vezi colecția de toamnă';
        done.appendChild(t); done.appendChild(x); done.appendChild(a);
        signup.appendChild(done);
        signup.classList.add('bz-done');
        var stickyBtn = document.querySelector('[data-bz-sticky]');
        if (stickyBtn) stickyBtn.remove();
        done.focus({ preventScroll: true });
        done.scrollIntoView({ block: 'center' });
      }
    }, 300);
  }

  // Butonul fix de pe telefon: apare după ce formularul iese din ecran.
  var sticky = document.querySelector('[data-bz-sticky]');
  if (sticky && signup && 'IntersectionObserver' in window && !document.querySelector('[data-bz-success]')) {
    var formVisible = true;
    var pastForm = false;
    var typing = false;
    var update = function () { sticky.hidden = formVisible || typing || !pastForm; };

    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        formVisible = entry.isIntersecting;
        pastForm = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      });
      update();
    }, { threshold: 0 }).observe(signup);

    document.addEventListener('focusin', function (e) { if (e.target.matches('input')) { typing = true; update(); } });
    document.addEventListener('focusout', function () { typing = false; update(); });

    sticky.addEventListener('click', function () {
      setTimeout(function () {
        var first = document.querySelector('#bz-inscriere input');
        if (first) first.focus({ preventScroll: true });
      }, 450);
    });
  }
})();

/* Ușa care se deschide, invitația și numărătoarea (conceptul „Primele”). */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var doors = document.querySelector('[data-bz-doors]');
  var media = doors && doors.parentElement;
  var img = media && media.querySelector('img');
  var invite = document.querySelector('[data-bz-invite]');

  var intro = document.documentElement.classList.contains('bz-intro');

  var showInvite = function () {
    if (!invite) return;
    invite.classList.remove('is-waiting');
    invite.classList.add('is-in');
  };

  if (doors && intro) {
    var started = false;
    var open = function () {
      if (started) return;
      started = true;
      requestAnimationFrame(function () {
        doors.classList.add('is-open');
        media.classList.add('is-open');
      });
      setTimeout(showInvite, 900);
      setTimeout(function () { doors.remove(); document.documentElement.classList.remove('bz-intro'); }, 3000);
      try { sessionStorage.setItem('bzDoorsSeen', '1'); } catch (e) {}
    };
    if (img && !img.complete) img.addEventListener('load', function () { setTimeout(open, 350); });
    else setTimeout(open, 500);
    setTimeout(open, 2500); // plasă: nu ținem ușa închisă dacă imaginea întârzie
  } else {
    if (doors) doors.remove();
    showInvite();
  }

  // Numărătoarea până la deschiderea colecției pentru listă.
  var count = document.querySelector('[data-bz-count]');
  var target = invite && Date.parse(invite.dataset.openAt || '');
  if (count && target && target > Date.now()) {
    var dEl = count.querySelector('[data-d]'), hEl = count.querySelector('[data-h]'), mEl = count.querySelector('[data-m]');
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var tick = function () {
      var left = Math.max(0, target - Date.now());
      var d = Math.floor(left / 864e5), h = Math.floor(left % 864e5 / 36e5), m = Math.floor(left % 36e5 / 6e4);
      dEl.textContent = d; hEl.textContent = pad(h); mEl.textContent = pad(m);
      dEl.nextSibling.textContent = d === 1 ? ' zi' : ' zile';
      hEl.nextSibling.textContent = h === 1 ? ' oră' : ' ore';
      mEl.nextSibling.textContent = m === 1 ? ' minut' : ' minute';
      if (left === 0) count.hidden = true;
    };
    tick();
    count.hidden = false;
    setInterval(tick, 30000);
  }

  // Înclinarea cardului: după mouse pe desktop, după derulare pe telefon.
  var card = invite && invite.querySelector('.bz-invite__card');
  if (card && !reduce) {
    var fine = window.matchMedia('(pointer: fine)').matches;
    if (fine) {
      invite.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        card.style.setProperty('--ry', (x * 10).toFixed(2) + 'deg');
        card.style.setProperty('--rx', (-y * 8).toFixed(2) + 'deg');
      });
      invite.addEventListener('pointerleave', function () {
        card.style.setProperty('--ry', '0deg');
        card.style.setProperty('--rx', '0deg');
      });
    } else {
      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var r = card.getBoundingClientRect();
          var p = Math.max(-1, Math.min(1, (r.top + r.height / 2) / window.innerHeight * 2 - 1));
          card.style.setProperty('--rx', (p * 7).toFixed(2) + 'deg');
          ticking = false;
        });
      }, { passive: true });
    }
  }
})();

/* Pregătește-ți coșul: taburi, adăugare în coș, lista salvată pe dispozitiv, notificare. */
(function () {
  'use strict';
  var shop = document.getElementById('bz-cos');
  if (!shop) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var KEY = 'bzBfList';
  var toast = document.querySelector('[data-bz-toast]');
  var countEl = document.querySelector('[data-bz-cartcount]');
  var cartLink = document.querySelector('[data-bz-cartlink]');
  var toastTimer;

  var say = function (text, withLink) {
    if (!toast) return;
    toast.innerHTML = '';
    var s = document.createElement('span'); s.textContent = text; toast.appendChild(s);
    if (withLink) { var a = document.createElement('a'); a.href = root + 'cart'; a.textContent = 'Vezi coșul'; toast.appendChild(a); }
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 4500);
  };
  var setCount = function (n) {
    if (!countEl) return;
    countEl.textContent = n;
    if (cartLink) { cartLink.classList.remove('is-bump'); void cartLink.offsetWidth; cartLink.classList.add('is-bump'); }
  };
  var refreshCount = function () {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count); return c; });
  };
  var addItems = function (items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  };

  // Lista salvată pe dispozitiv
  var read = function () { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } };
  var write = function (l) { try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (e) {} };
  var listBox = shop.querySelector('[data-bz-list]');
  var listUl = shop.querySelector('[data-bz-list-items]');
  var render = function () {
    if (!listBox) return;
    var l = read();
    listBox.hidden = l.length === 0;
    listUl.innerHTML = '';
    l.forEach(function (it) {
      var li = document.createElement('li');
      var img = document.createElement('img'); img.src = it.img || ''; img.alt = ''; img.width = 44; img.height = 66; img.loading = 'lazy';
      var a = document.createElement('a'); a.href = it.url; a.textContent = it.title;
      if (it.size) { var sm = document.createElement('small'); sm.textContent = 'Mărime: ' + it.size; a.appendChild(sm); }
      var x = document.createElement('button'); x.type = 'button'; x.setAttribute('aria-label', 'Scoate din listă: ' + it.title); x.textContent = '×';
      x.addEventListener('click', function () { write(read().filter(function (o) { return o.id !== it.id; })); render(); });
      li.appendChild(img); li.appendChild(a); li.appendChild(x); listUl.appendChild(li);
    });
  };
  render();

  var addAll = shop.querySelector('[data-bz-list-add]');
  if (addAll) addAll.addEventListener('click', function () {
    var l = read(); if (!l.length) return;
    addAll.disabled = true;
    refreshCount().then(function (cart) {
      var inCart = (cart.items || []).map(function (i) { return i.variant_id; });
      var todo = l.filter(function (o) { return inCart.indexOf(o.id) === -1; });
      if (!todo.length) { say('Piesele din listă sunt deja în coș.', true); return; }
      // una câte una, ca o mărime epuizată să nu oprească restul
      var ok = 0, gone = 0;
      return todo.reduce(function (p, o) {
        return p.then(function () { return addItems([{ id: o.id, quantity: 1 }]).then(function () { ok++; }, function () { gone++; }); });
      }, Promise.resolve()).then(function () {
        refreshCount();
        if (gone && ok) say('Am adăugat ' + ok + (ok === 1 ? ' piesă' : ' piese') + ' în coș. ' + (gone === 1 ? 'Pentru o piesă din listă, mărimea aleasă nu mai este în stoc.' : 'Pentru ' + gone + ' piese din listă, mărimile alese nu mai sunt în stoc.'), true);
        else if (gone) say('Mărimile alese pentru piesele din listă nu mai sunt în stoc. Poți alege alte mărimi.', false);
        else say('Am adăugat piesele în coș.', true);
      });
    }).catch(function () { say('Nu am putut adăuga piesele în coș. Încearcă din nou.', false); })
      .then(function () { addAll.disabled = false; });
  });

  // Adăugare din carduri
  shop.querySelectorAll('form[data-bz-add]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var sel = form.querySelector('select');
      var input = form.querySelector('[name="id"]');
      var id = parseInt(input.value, 10);
      if (!id) {
        if (sel) { sel.setAttribute('aria-invalid', 'true'); sel.focus(); }
        say('Alege mărimea, apoi adaugă piesa în coș.', false);
        return;
      }
      if (sel) sel.removeAttribute('aria-invalid');
      var btn = form.querySelector('button'); btn.disabled = true;
      var card = form.closest('.bz-prod');
      addItems([{ id: id, quantity: 1 }]).then(function () {
        var size = sel ? sel.options[sel.selectedIndex].text : '';
        var l = read().filter(function (o) { return o.id !== id; });
        l.unshift({ id: id, title: card.dataset.title, url: card.dataset.url, img: card.dataset.img, size: size });
        write(l.slice(0, 20)); render();
        btn.classList.add('is-done'); btn.textContent = 'Adăugată în coș';
        setTimeout(function () { btn.classList.remove('is-done'); btn.textContent = 'Adaugă în coș'; }, 2500);
        say('Am adăugat piesa în coș.', true);
        return refreshCount();
      }).catch(function (err) {
        var sold = err && (err.status === 422 || /stoc|stock|sold/i.test(err.description || err.message || ''));
        say(sold ? 'Mărimea aleasă nu mai este în stoc. Alege altă mărime.' : 'Nu am putut adăuga piesa. Încearcă din nou.', false);
      }).then(function () { btn.disabled = false; });
    });
    var s = form.querySelector('select');
    if (s) s.addEventListener('change', function () { s.removeAttribute('aria-invalid'); });
  });

  // Taburi
  var tabs = Array.prototype.slice.call(shop.querySelectorAll('[data-bz-tab]'));
  var pick = function (t) {
    tabs.forEach(function (o) {
      var on = o === t;
      o.setAttribute('aria-selected', on ? 'true' : 'false');
      o.tabIndex = on ? 0 : -1;
      var p = document.getElementById(o.getAttribute('aria-controls'));
      if (p) p.hidden = !on;
    });
  };
  tabs.forEach(function (t, i) {
    t.addEventListener('click', function () { pick(t); });
    t.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
      pick(n); n.focus();
    });
  });
})();
